// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Product Catalogue API
 * Endpoints for querying product catalogue data including products and their versions.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Product } from './Product';
import {
  ProductFromJSON,
  ProductFromJSONTyped,
  ProductToJSON,
  ProductToJSONTyped,
} from './Product';

/**
 *
 * @export
 * @interface GetProductsResponse
 */
export interface GetProductsResponse {
  /**
   *
   * @type {Array<Product>}
   * @memberof GetProductsResponse
   */
  data: Array<Product>;
}

/**
 * Check if a given object implements the GetProductsResponse interface.
 */
export function instanceOfGetProductsResponse(
  value: object,
): value is GetProductsResponse {
  if (!('data' in value) || value['data'] === undefined) return false;
  return true;
}

export function GetProductsResponseFromJSON(json: any): GetProductsResponse {
  return GetProductsResponseFromJSONTyped(json, false);
}

export function GetProductsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GetProductsResponse {
  if (json == null) {
    return json;
  }
  return {
    data: (json['data'] as Array<any>).map(ProductFromJSON),
  };
}

export function GetProductsResponseToJSON(json: any): GetProductsResponse {
  return GetProductsResponseToJSONTyped(json, false);
}

export function GetProductsResponseToJSONTyped(
  value?: GetProductsResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    data: (value['data'] as Array<any>).map(ProductToJSON),
  };
}
